module.exports = __webpack_public_path__ + "static/media/task-notification-success.dbb37620.svg";